import Axios from "../../config/Axios";
import Apis from "../../config/Apis";
import { headers } from "../../utills";
import {
  cus_getUnlinkAssets,
  cus_setAssetStatus,
  get_cus_assets,
  get_cus_assetsDetail,
  get_cus_dashboard,
} from "../Actions/CusAssetsAction";
import { hideLoading, showAlert, showLoading } from "../Actions/GeneralActions";
import { get_cus_module_detail } from "../Actions/CusModuleAction";

export const CusAssetsMiddleware = {
  getCusDashboard: ({ name }) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("name", name);

          const data = await Axios.post(
            Apis.cus_dashboard,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            dispatch(get_cus_dashboard(data.data.data));
            resolve(data.data.data);
          }
        } catch (error) {
          dispatch(
            showAlert({
              title: "getDashboard",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : "Something went wrong!",
              type: "Error",
              status: error?.response?.status,
            }),
          );
        }
      });
    };
  },
  createCusAssets: (params) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          let formdata = new FormData();
          if (params?.assetImage) formdata.append("image", params?.assetImage);
          if (params?.name) formdata.append("name", params?.name);
          if (params?.make) formdata.append("make", params?.make);
          if (params?.model) formdata.append("model", params?.model);
          if (params?.vinNo) formdata.append("vin_no", params?.vinNo);
          if (params?.licenseNo)
            formdata.append("license_no", params?.licenseNo);
          if (params?.batteryVolt)
            formdata.append("battery_volt", params?.batteryVolt);
          if (params?.trim) formdata.append("trim", params?.trim);
          if (params?.color) formdata.append("color", params?.color);
          if (params?.stock) formdata.append("stock_no", params?.stock);
          if (params?.year) formdata.append("year", params?.year);
          if (params?.deviceId) formdata.append("device_id", params?.deviceId);
          if (params?.deviceName)
            formdata.append("device_name", params?.deviceName);

          const data = await Axios.post(
            Apis.cus_createAssets,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            dispatch(
              showAlert({ type: "success", message: data?.data?.message }),
            );

            dispatch(get_cus_assets(data.data.data));

            resolve(true);
          }
        } catch (error) {
          dispatch(
            showAlert({
              title: "createAssets",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : "Something went wrong!",
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  UpdateCusAssets: (params) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          let formdata = new FormData();
          formdata.append("id", params?.id);
          if (params?.assetImage) formdata.append("image", params?.assetImage);
          if (params?.name) formdata.append("name", params?.name);
          if (params?.make) formdata.append("make", params?.make);
          if (params?.model) formdata.append("model", params?.model);
          if (params?.vinNo) formdata.append("vin_no", params?.vinNo);
          if (params?.licenseNo)
            formdata.append("license_no", params?.licenseNo);
          if (params?.batteryVolt)
            formdata.append("battery_volt", params?.batteryVolt);
          if (params?.trim) formdata.append("trim", params?.trim);
          if (params?.color) formdata.append("color", params?.color);
          if (params?.stock) formdata.append("stock_no", params?.stock);
          if (params?.year) formdata.append("year", params?.year);
          if (params?.deviceId) formdata.append("device_id", params?.deviceId);
          if (params?.deviceName)
            formdata.append("device_name", params?.deviceName);
          const data = await Axios.post(
            Apis.cus_updateAssets,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            dispatch(
              showAlert({ type: "success", message: data?.data?.message }),
            );

            dispatch(get_cus_assets(data.data.data));
            resolve(true);
          }
        } catch (error) {
          dispatch(
            showAlert({
              title: "updateAssets",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : "Something went wrong!",
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  getCusAssets: ({ name }) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          let formdata = new FormData();

          formdata.append("name", name);

          const data = await Axios.post(
            Apis.cus_Assets,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            dispatch(get_cus_assets(data.data.data));
            dispatch(get_cus_module_detail(null));

            resolve(data.data.data);
          }
        } catch (error) {
          dispatch(
            showAlert({
              title: "getAssets",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : "Something went wrong!",
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  getCusAssetsDetail: ({ id }) => {
    // console.log("idddd", id);

    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const data = await Axios.get(
            Apis.cus_assetDetail(id),
            headers.config(),
          );
          if (data?.status == 200) {
            dispatch(hideLoading());
            dispatch(get_cus_assetsDetail(data.data.data));
            dispatch(
              cus_setAssetStatus({
                device_id: data?.data?.data?.device_id,
                status: data?.data?.data?.status,
              }),
            );
            resolve(data);
          }
        } catch (error) {
          dispatch(
            showAlert({
              title: "getAssetsDetail",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : "Something went wrong!",
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  DeleteAsset: ({ id }) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          let formdata = new FormData();
          if (id) formdata.append("id", id);

          const data = await Axios.post(
            Apis.cus_deleteAssets,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            dispatch(
              showAlert({ type: "success", message: data?.data?.message }),
            );
            dispatch(get_cus_assets(data.data.data));
            resolve(true);
          }
        } catch (error) {
          dispatch(
            showAlert({
              title: "DeleteGroup",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : "Something went wrong!",
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  sentDownlink: ({ device_id, action, status, asset_id }) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());

          let formdata = new FormData();
          formdata.append("action", action);
          formdata.append("device_id", device_id);
          if (asset_id) formdata.append("asset_id", asset_id);
          if (status) formdata.append("status", status);

          console.log(formdata);
          const data = await Axios.post(
            Apis.cus_downlink,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            resolve(true);
            if (status) dispatch(cus_setAssetStatus({ device_id, status }));
          }
        } catch (error) {
          dispatch(
            showAlert({
              title: "sentDownlink",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : "Something went wrong!",
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  createUpdateSchedule: (userdata) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          let formdata = new FormData();
          formdata.append("asset_id", userdata?.assetId);
          if (userdata?.scheduleId)
            formdata.append("schedule_id", userdata?.scheduleId);
          formdata.append("name", userdata?.title);
          formdata.append("start_time", userdata?.startTime);
          formdata.append("end_time", userdata?.endTime);
          formdata.append("start_date", userdata?.startDate);
          formdata.append("end_date", userdata?.endDate);
          formdata.append("frequency", userdata?.frequency);
          formdata.append("start_date", userdata?.startDate);
          formdata.append("end_date", userdata?.endDate);

          resolve(true);
          const data = await Axios.post(
            Apis.cus_createUpdateSchedule,
            formdata,
            headers.config("application/json"),
          );
          if (data?.status == 200) {
            resolve(true);
            dispatch(
              showAlert({ type: "success", message: data?.data?.message }),
            );

            dispatch(get_cus_assetsDetail(data?.data?.data));
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "create schedule",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  updateStatusSchedule: ({ id }) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const data = await Axios.get(
            Apis.cus_updateStatusSchedule(id),
            headers.config(),
          );
          if (data?.status == 200) {
            dispatch(get_cus_assetsDetail(data.data.data));
            resolve(true);
          }
        } catch (error) {
          dispatch(
            showAlert({
              title: "updateStatusSchedule",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : "Something went wrong!",
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  DeleteAssetSchedule: ({ id }) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          let formdata = new FormData();
          if (id) formdata.append("id", id);

          const data = await Axios.post(
            Apis.cus_deleteAssetSchedule,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            dispatch(get_cus_assetsDetail(data.data.data));
            resolve(true);
          }
        } catch (error) {
          dispatch(
            showAlert({
              title: "DeleteAssetSchedule",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : "Something went wrong!",
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  unlinkAsset: ({ id }) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const data = await Axios.get(
            Apis.cus_unlinkAssets(id),
            headers.config(),
          );
          if (data?.status == 200) {
            dispatch(get_cus_assetsDetail(data.data.data));
            resolve(true);
          }
        } catch (error) {
          dispatch(
            showAlert({
              title: "unlinkAsset",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : "Something went wrong!",
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  updateBatteryVolt: ({ battery_volt, asset_id }) => {
    return (dispatch) => {
      // dispatch(showLoading())
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          if (battery_volt) formdata.append("battery_volt", battery_volt);
          if (asset_id) formdata.append("asset_id", asset_id);
          const data = await Axios.post(
            Apis.getBatteryVolt,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            resolve(true);
            dispatch(get_cus_assetsDetail(data.data.data));
          }
        } catch (error) {
          dispatch(
            showAlert({
              title: "shareAccess",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : "Something went wrong!",
              type: "Error",
              status: error?.response?.status,
            }),
          );
        }
      });
    };
  },

  sentDownlinkBattery: ({ device_id, action, status, asset_id }) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("action", action);
          formdata.append("device_id", device_id);
          if (asset_id) formdata.append("asset_id", asset_id);
          if (status) formdata.append("status", status);

          console.log(formdata);
          const data = await Axios.post(
            Apis.cus_downlink,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            resolve(true);
            if (status) dispatch(cus_setAssetStatus({ device_id, status }));
          }
        } catch (error) {
          dispatch(
            showAlert({
              title: "sentDownlink",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : "Something went wrong!",
              type: "Error",
              status: error?.response?.status,
            }),
          );
        }
      });
    };
  },
  cusAssignAsset: (userdata) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const formdata = new FormData();
          formdata.append("id", userdata?.assetId);
          formdata.append("device_id", userdata?.deviceId);
          const data = await Axios.post(
            Apis.cus_assignAsset,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            resolve(data);
            dispatch(
              showAlert({ type: "success", message: data?.data?.message }),
            );
            dispatch(get_cus_module_detail(data.data.data));
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "Modules",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  getCusUnlinkAssets: (userdata) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const formdata = new FormData();
          if (userdata) formdata.append("name", userdata);
          const data = await Axios.post(
            Apis.cus_getUnlinkAssets,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            resolve(data);

            dispatch(cus_getUnlinkAssets(data?.data?.data));
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "login",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
};
